import { ReachWorkspaceType } from '../types/workspaces-types.type';

export const invalidWorkspacesTypes = [
	ReachWorkspaceType.UNASSIGNED_NODES,
	ReachWorkspaceType.TRASHED_NODES,
];
